import {
  AudioRecordingRef,
  AudioUploadProgressTracker,
  AudioUploadProgressStateStore,
  AudioUploadProgressUpdate,
} from "@/store/audio/uploading/audio-uploading.types";

type RendererAudioUploadProgressTrackerConfig = {
  progressStore: AudioUploadProgressStateStore;
};

export class RendererAudioUploadProgressTracker implements AudioUploadProgressTracker {
  private readonly progressStore: AudioUploadProgressStateStore;

  constructor({ progressStore }: RendererAudioUploadProgressTrackerConfig) {
    this.progressStore = progressStore;
  }

  setProgress(args: AudioUploadProgressUpdate): void {
    this.progressStore.setProgress(args);
  }

  clearProgress(args: AudioRecordingRef): void {
    this.progressStore.clearProgress(args);
  }
}
